import styled from 'styled-components';
import { MLBTheme } from '../../style/theme.types';
import {
  AccordionIconTypeTypes,
  AccordionIconThemeTypes,
  AccordionIconSizeTypes,
  SizeMap,
  ContentType,
  IconWrapperType,
} from './AccordionItem.types';
import COLORS, { Color } from '../../style/universal.color';

/** Color Maps */

const LOCAL_COLORS: Color = {
  arrowBgDark: '#e6f2ff',
};

const { arrowBgDark } = LOCAL_COLORS;
const { mlbGrey2, mlbGrey5, mlbGrey7, linkBlue, mlbWhite, starsBlue, mlbBlack, linkBlueOnDark } = COLORS;

export const standardArrowColorMap: {
  arrowColor: Color;
  arrowBackground: Color;
} = {
  arrowColor: {
    dark: starsBlue,
    light: mlbGrey5,
  },
  arrowBackground: {
    dark: 'none',
    light: 'none',
  },
};

export const circularArrowColorMap: {
  arrowColor: Color;
  arrowBackground: Color;
} = {
  arrowColor: {
    dark: linkBlue,
    light: mlbGrey5,
  },
  arrowBackground: {
    dark: arrowBgDark,
    light: mlbWhite,
  },
};

/** Size maps */
export const sizeCircularMap: SizeMap = {
  sm: 7.3,
  lg: 8.1,
};

export const sizeStandardMap: SizeMap = {
  sm: 7.8,
  lg: 10.2,
};

/** Styled Components */

export const Content = styled.div<ContentType>`
  color: ${({ theme }) => (theme.dark ? mlbWhite : mlbBlack)};
  ${({ isAccordionOpened, animate }) => (animate ? '' : `display: ${isAccordionOpened ? 'block' : 'none'}`)};
  background: ${({ theme }) => (theme!.dark ? mlbBlack : mlbWhite)};
`;

export const Button = styled.button.attrs(() => ({ type: 'button' }))`
  width: 100%;
  height: 53px;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  &:focus {
    outline: 0;
  }
  &::-moz-focus-inner {
    border: 0;
  }
`;

export const Text = styled.span`
  font-family: ${({ theme = {} }) => theme.fonts?.family?.primary};
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  padding-left: 16px;
  padding-right: 16px;
  white-space: nowrap;
`;

export const HeadLine = styled(Text)`
  color: ${({ theme = {} }: { theme: MLBTheme }) => (theme.dark ? mlbGrey2 : mlbGrey7)};
`;

export const SubHeader = styled(Text)`
  letter-spacing: 0.64px;
  text-align: right;
  color: ${({ theme = {} }: { theme: MLBTheme }) => (theme.dark ? linkBlueOnDark : linkBlue)};
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const SubHeading = styled.div`
  display: flex;
  padding: 5px 9px 5px 0;
  align-items: center;
  overflow: hidden;
`;

export const IconWrapper = styled.div<IconWrapperType>`
  width: ${({ iconSize }: IconWrapperType) => (iconSize === AccordionIconSizeTypes.LG ? '20px' : '18px')};
  height: ${({ iconSize }: IconWrapperType) => (iconSize === AccordionIconSizeTypes.LG ? '20px' : '18px')};
  transform: ${({ iconRotated }: IconWrapperType) => (iconRotated ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease-in-out;
  opacity: 0.88;
  background-color: ${({ iconType, iconTheme }: IconWrapperType) =>
    iconType === AccordionIconTypeTypes.STANDARD
      ? standardArrowColorMap.arrowBackground[iconTheme!]
      : circularArrowColorMap.arrowBackground[iconTheme!]};
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
  box-shadow: ${({ iconType, iconTheme }: IconWrapperType) =>
    iconType === AccordionIconTypeTypes.CIRCULAR && iconTheme === AccordionIconThemeTypes.LIGHT
      ? '0 2px 4px 0 rgba(0, 0, 0, 0.08)'
      : 'none'};
`;
